import React from "react";
import UserCard from "./UserCard";
import type { User } from "../UsuariosPageNew";

interface UserGridProps {
    usuarios: User[];
    loading: boolean;
    onUserClick: (user: User) => void;
    onActionClick: (user: User, type: "status" | "superhost", e?: React.MouseEvent) => void;
}

const UserGrid: React.FC<UserGridProps> = ({ usuarios, loading, onUserClick, onActionClick }) => {
    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center py-20">
                <svg className="animate-spin h-8 w-8 text-[#4f6df5]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" strokeDasharray="30" strokeLinecap="round" />
                </svg>
                <p className="mt-4 text-sm text-gray-500">Obteniendo usuarios...</p>
            </div>
        );
    }

    if (usuarios.length === 0) {
        return (
            <div className="text-center py-20 border-2 border-dashed border-gray-200 bg-gray-50/50 rounded-xl text-gray-500 text-sm">
                No se encontraron usuarios para este filtro.
            </div>
        );
    }

    return (
        <div className="grid grid-cols-[repeat(auto-fill,minmax(240px,1fr))] gap-3.5">
            {usuarios.map((user) => (
                <UserCard
                    key={user.userId}
                    user={user}
                    onUserClick={onUserClick}
                    onActionClick={onActionClick}
                />
            ))}
        </div>
    );
};

export default UserGrid;